import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import { Codebook } from '../Codebook'

export enum EmployeeRoleId {
  ADMIN = 1,
  DEVELOPER = 2,
  SUPPORT = 3,
  MARKETING = 4,
  USER_MANAGER = 5,
  INVOICING = 6,
  CHANNEL_MANAGER = 7,
  TESTING = 8,
  SALES_DIRECTOR = 9,
  SALESMAN = 10,
}

type EmployeeRoleColor =
  | Color.WARNING
  | Color.INFO
  | Color.POSITIVE
  | Color.PRIMARY
  | Color.NEGATIVE
  | Color.GREY_600

export class EmployeeRole extends Codebook<EmployeeRoleId> {
  static readonly ADMIN = new EmployeeRole(EmployeeRoleId.ADMIN, () => $t('Admin'), Color.WARNING)
  static readonly DEVELOPER = new EmployeeRole(
    EmployeeRoleId.DEVELOPER,
    () => $t('Developer'),
    Color.INFO,
  )
  static readonly SUPPORT = new EmployeeRole(
    EmployeeRoleId.SUPPORT,
    () => $t('Support'),
    Color.POSITIVE,
  )
  static readonly MARKETING = new EmployeeRole(
    EmployeeRoleId.MARKETING,
    () => $t('Marketing'),
    Color.PRIMARY,
  )
  static readonly USER_MANAGER = new EmployeeRole(
    EmployeeRoleId.USER_MANAGER,
    () => $t('User manager'),
    Color.NEGATIVE,
  )
  static readonly INVOICING = new EmployeeRole(
    EmployeeRoleId.INVOICING,
    () => $t('Invoicing'),
    Color.PRIMARY,
  )
  static readonly CHANNEL_MANAGER = new EmployeeRole(
    EmployeeRoleId.CHANNEL_MANAGER,
    () => $t('Channel manager'),
    Color.PRIMARY,
  )
  static readonly TESTING = new EmployeeRole(
    EmployeeRoleId.TESTING,
    () => $t('Testing'),
    Color.GREY_600,
  )
  static readonly SALES_DIRECTOR = new EmployeeRole(
    EmployeeRoleId.SALES_DIRECTOR,
    () => $t('Sales director'),
    Color.INFO,
  )
  static readonly SALESMAN = new EmployeeRole(
    EmployeeRoleId.SALESMAN,
    () => $t('Salesman'),
    Color.POSITIVE,
  )

  private constructor(
    public readonly id: EmployeeRoleId,
    public readonly name: () => string,
    public readonly color: EmployeeRoleColor,
  ) {
    super(id)
  }
}
